import { scrollTop } from 'utils/wrappers';
import FulfillmentProducts from 'app/collections/fulfillment_products';
import Paginator from 'app/models/paginator';
import ApiModeToggle from 'app/views/api_mode_toggle';

import Base from 'app/views/base';
import PaginationView from 'app/views/pagination_view';

import { List as ListView, Heading } from 'app/components/list/list';
import ListSearchView from 'app/components/list/search';
import { DetailBlock } from 'app/components/list/item_details';

import tmpl from './template';

const HEADINGS = [
  new Heading({ property: 'title', display: 'Name', xsSize: 9, smSize: 8 }),
  new Heading({ property: 'count', display: 'Qty', xsSize: 3, smSize: 2 })
];

const PAGE_SIZE = 10;

function formatWarehouseInventory (inventory) {
  if (!inventory) { return ''; }
  return `${inventory.city}, ${inventory.state}: ${inventory.inventory}`;
}

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_products',

  initialize() {
    this.collection = new FulfillmentProducts([], { apiMode: this.model });

    this.listenTo(this.collection, 'update', this.render);
    this.listenTo(this.collection, 'sync', scrollTop);
    this.listenTo(this.collection, 'sync', this.loadInventoryData);

    this.paginator = new Paginator({
      collection: this.collection,
      pageSize: PAGE_SIZE,
      buildParams() {
        return {
          limit: PAGE_SIZE,
          page: this.get('currentPage'),
          offset: this.get('currentPage') * PAGE_SIZE,
        };
      }
    });

    this.addSubview('productList', '#product_list', new ListView({
      headings: HEADINGS,
      collection: this.collection,
      user: this.user,
      noResultsMessage: 'No products found matching your filter set.',
      showDetails: {
        mainHeading: m => m.get('id'),
        detailBlocks: [
          new DetailBlock({
            heading: 'Inventories',
            items: m => Object.keys(m.getInventory())
                          .map(i => formatWarehouseInventory(m.getInventory(i)))
          }),
          new DetailBlock({
            heading: 'Size',
            items: m => [`${m.get('length').value} ${m.get('length').unit || ''} x ` +
            `${m.get('width').value} ${m.get('width').unit || ''}`],
          }),
          new DetailBlock({
            heading: 'Weight',
            items: m => [`${m.get('weight').value} ${m.get('weight').unit || ''}`],
          }),
          new DetailBlock({
            heading: 'Price',
            items: m => [`${m.get('price').value} ${m.get('price').unit || ''}`],
          }),
        ]
      },
    }));

    this.addSubview('pagination', '#product_pagination', new PaginationView({ model: this.paginator }));
    this.addSubview('apiModeToggle', '#api_mode_toggle', new ApiModeToggle({ model: this.model }));
    this.addSubview('search', '#product_search', new ListSearchView({
      collection: this.collection,
      placeholder: '(Product Id)',
    }));
  },

  loadInventoryData() {
    this.collection.models.forEach(m => m.fetchWarehouses());
  }
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_products/index.js